import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { formatCurrency, CURRENCY_SYMBOLS } from '../../utils/currencyUtils';
import LoadingSpinner from '../common/Loader';

// Добавляем SVG иконки
const SVG_ICONS = {
  piggybank: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.83 7.5l-2.27-2.27c.07-.42.18-.81.32-1.15.1-.23.21-.46.34-.65-.18.01-.36.03-.55.03-1.95 0-3.67-1.51-3.67-3.46h-2c0 1.96-1.72 3.46-3.67 3.46-.19 0-.37-.02-.55-.03.13.2.25.42.35.65.14.34.25.73.32 1.15L6.17 7.5c-.88.88-1.17 1.17-1.17 2V18c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V9.5c0-.83-.29-1.12-1.17-2zM10 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/></svg>`,
  wallet: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg>`,
  money: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/></svg>`,
  home: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/></svg>`,
  car: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"/></svg>`,
  education: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/></svg>`,
  retirement: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"/></svg>`,
  gift: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"/></svg>`,
  travel: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"/></svg>`,
  growth: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"/></svg>`,
  savings: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M19.83 7.5l-2.27-2.27c.07-.42.18-.81.32-1.15.1-.23.21-.46.34-.65-.18.01-.36.03-.55.03-1.95 0-3.67-1.51-3.67-3.46h-2c0 1.96-1.72 3.46-3.67 3.46-.19 0-.37-.02-.55-.03.13.2.25.42.35.65.14.34.25.73.32 1.15L6.17 7.5c-.88.88-1.17 1.17-1.17 2V18c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V9.5c0-.83-.29-1.12-1.17-2zM12 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>`,
  icon1: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>`,
  icon2: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z"/></svg>`,
  icon3: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm5-11H7v2h10z"/></svg>`,
};

const GoalsListContainer = styled.div`
  margin-top: 20px;
`;

const NoGoalsMessage = styled.p`
  text-align: center;
  color: #8c96a5;
  padding: 20px;
  background: #f0f3f9;
  border-radius: 8px;
  margin: 0;
`;

const GoalItem = styled.div`
  background: linear-gradient(145deg, #ffffff, #f5f6fa);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.05),
              -2px -2px 10px rgba(255, 255, 255, 0.8);
  transition: transform 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const GoalHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

// ОБНОВЛЕННЫЙ GoalIcon для отображения SVG
const GoalIcon = styled.div`
  width: 40px;
  height: 40px;
  margin-right: 16px;
  background: #f0f3f9;
  padding: 8px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  
  svg {
    width: 24px;
    height: 24px;
    color: #4a6fa1;
  }
`;

const GoalTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #4a6fa1;
  margin: 0;
`;

const GoalInfo = styled.div`
  margin-bottom: 16px;
`;

const GoalDetails = styled.p`
  font-size: 14px;
  color: #7a8599;
  margin: 8px 0;
  display: flex;
  justify-content: space-between;
  
  span:last-child {
    font-weight: 500;
    color: #4a6fa1;
  }
`;

const ProgressBarContainer = styled.div`
  height: 12px;
  background: #e6ebf5;
  border-radius: 6px;
  overflow: hidden;
  margin: 12px 0;
  box-shadow: inset 1px 1px 3px rgba(0, 0, 0, 0.1);
`;

const ProgressBarFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #4a6fa1, #5d82b3);
  border-radius: 6px;
  width: ${props => props.$progress}%;
  transition: width 0.5s ease;
`;

const ProgressInfo = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  
  span:first-child {
    color: #7a8599;
  }
  
  span:last-child {
    color: #4a6fa1;
    font-weight: 500;
  }
`;

const GoalStatus = styled.div`
  font-weight: 500;
  padding: 6px 12px;
  border-radius: 4px;
  display: inline-block;
  margin-top: 8px;
  
  &.completed {
    background-color: rgba(46, 204, 113, 0.2);
    color: #27ae60;
  }
  
  &.overdue {
    background-color: rgba(231, 76, 60, 0.2);
    color: #c0392b;
  }
`;

const GoalActions = styled.div`
  margin-top: 16px;
  border-top: 1px solid #e6ebf5;
  padding-top: 16px;
`;

const UpdateProgressContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const InputWithSelectContainer = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  display: flex;
  
  @media (max-width: 576px) {
    margin-bottom: 8px;
  }
`;

const ProgressInput = styled.input`
  width: 100%;
  max-width: 65%;
  padding: 10px 12px;
  padding-right: 56px;
  border: 1px solid #dde2ec;
  border-radius: 8px 0 0 8px;
  background: #f0f3f9;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #4a6fa1;
  }
  
  @media (max-width: 576px) {
    max-width: 100%;
    border-radius: 8px;
  }
`;

const CurrencySelectWrapper = styled.div`
  position: absolute;
  top: 1px;
  right: 1px;
  bottom: 1px;
  width: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e6ebf5;
  border-left: 1px solid #dde2ec;
  border-radius: 0 7px 7px 0;
  z-index: 1;
`;

const CurrencySelect = styled.select`
  width: 100%;
  height: 100%;
  padding: 0 18px 0 5px;
  border: none;
  background: transparent;
  color: #4a6fa1;
  font-weight: 500;
  cursor: pointer;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  text-align: center;
  
  &:focus {
    outline: none;
  }
`;

const UpdateButton = styled.button`
  min-width: 120px;
  padding: 10px 16px;
  margin-left: 10px;
  background: linear-gradient(145deg, #4a6fa1, #5d82b3);
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: linear-gradient(145deg, #3d5e8a, #4a6fa1);
  }
  
  &:active {
    transform: translateY(1px);
  }
  
  @media (max-width: 576px) {
    width: 100%;
    margin-left: 0;
  }
`;

const SelectArrow = styled.div`
  position: absolute;
  right: 6px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #4a6fa1;
`;

const DeleteButton = styled.button`
  padding: 10px 16px;
  background: transparent;
  color: #e74c3c;
  border: 1px solid #e74c3c;
  border-radius: 8px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(231, 76, 60, 0.1);
  }
  
  &:active {
    transform: translateY(1px);
  }
`;

const GoalsList = ({ goals, isLoading, onUpdateProgress, onDeleteGoal, defaultCurrency }) => {
  const { t } = useTranslation();
  const [progressInputs, setProgressInputs] = useState({});
  const [progressCurrencies, setProgressCurrencies] = useState({});
  
  // Функция для получения SVG иконки
  const getGoalIcon = (iconKey) => {
    return SVG_ICONS[iconKey] || SVG_ICONS['piggybank']; // Fallback на копилку
  };
  
  const handleProgressInputChange = (goalId, value) => {
    setProgressInputs(prev => ({
      ...prev,
      [goalId]: value
    }));
  };
  
  const handleCurrencyChange = (goalId, currency) => {
    setProgressCurrencies(prev => ({
      ...prev,
      [goalId]: currency
    }));
  };
  
  const handleUpdateProgress = async (goalId) => {
    const amount = parseFloat(progressInputs[goalId]);
    if (!amount || isNaN(amount) || amount <= 0) {
      alert(t('enter_valid_amount'));
      return;
    }
    
    const currency = progressCurrencies[goalId] || defaultCurrency;
    const success = await onUpdateProgress(goalId, amount, currency);
    
    if (success) {
      // Сбрасываем поле ввода
      setProgressInputs(prev => ({
        ...prev,
        [goalId]: ''
      }));
      alert(t('goal_progress_updated'));
    } else {
      alert(t('goal_update_error'));
    }
  };
  
  const today = new Date();
  
  if (isLoading) {
    return (
      <GoalsListContainer>
        <LoadingSpinner />
      </GoalsListContainer>
    );
  }
  
  if (!goals.length) {
    return (
      <GoalsListContainer>
        <NoGoalsMessage>{t('no_goals_message')}</NoGoalsMessage>
      </GoalsListContainer>
    );
  }
  
  return (
    <GoalsListContainer>
      {goals.map(goal => {
        const goalCurrency = goal.currency || defaultCurrency;
        const progressPercentage = Math.min(
          (parseFloat(goal.current_amount) / parseFloat(goal.target_amount)) * 100,
          100
        ).toFixed(1);
        
        const isCompleted = parseFloat(goal.current_amount) >= parseFloat(goal.target_amount);
        const isOverdue = new Date(goal.due_date) < today && !isCompleted;
        
        // Инициализируем валюту для этой цели, если она еще не установлена
        if (!progressCurrencies[goal.id]) {
          setProgressCurrencies(prev => ({
            ...prev,
            [goal.id]: goalCurrency
          }));
        }
          
        return (
          <GoalItem key={goal.id}>
            <GoalHeader>
              {/* ИСПРАВЛЕННАЯ ЧАСТЬ - используем dangerouslySetInnerHTML для SVG */}
              <GoalIcon 
                dangerouslySetInnerHTML={{ 
                  __html: getGoalIcon(goal.icon) 
                }}
              />
              <GoalTitle>{goal.name}</GoalTitle>
            </GoalHeader>
            
            <GoalInfo>
              <GoalDetails>
                <span>{t('goal_amount_label')}</span>
                <span>{formatCurrency(goal.target_amount, goalCurrency)}</span>
              </GoalDetails>
              
              <GoalDetails>
                <span>{t('goal_date_label')}</span>
                <span>
                  {new Date(goal.due_date).toLocaleDateString(undefined, {
                    day: '2-digit',
                    month: '2-digit',
                    year: '2-digit'
                  })}
                </span>
              </GoalDetails>
              
              <ProgressBarContainer>
                <ProgressBarFill $progress={progressPercentage} />
              </ProgressBarContainer>
              
              <ProgressInfo>
                <span>{t('goal_progress_label')}</span>
                <span>
                  {formatCurrency(goal.current_amount, goalCurrency)} / {formatCurrency(goal.target_amount, goalCurrency)} 
                  ({progressPercentage}%)
                </span>
              </ProgressInfo>
              
              {isCompleted && (
                <GoalStatus className="completed">
                  {t('goal_completed')}
                </GoalStatus>
              )}
              
              {isOverdue && !isCompleted && (
                <GoalStatus className="overdue">
                  {t('goal_overdue')}
                </GoalStatus>
              )}
            </GoalInfo>
            
            <GoalActions>
              <UpdateProgressContainer>
                <InputWithSelectContainer>
                  <ProgressInput
                    type="number"
                    value={progressInputs[goal.id] || ''}
                    onChange={(e) => handleProgressInputChange(goal.id, e.target.value)}
                    placeholder={t('enter_progress')}
                    min="0.01"
                    step="0.01"
                  />
                  <CurrencySelectWrapper>
                    <CurrencySelect
                      value={progressCurrencies[goal.id] || goalCurrency}
                      onChange={(e) => handleCurrencyChange(goal.id, e.target.value)}
                    >
                      {Object.entries(CURRENCY_SYMBOLS).map(([code, symbol]) => (
                        <option key={code} value={code}>
                          {symbol}
                        </option>
                      ))}
                    </CurrencySelect>
                    <SelectArrow />
                  </CurrencySelectWrapper>
                </InputWithSelectContainer>
                <UpdateButton onClick={() => handleUpdateProgress(goal.id)}>
                  {t('add_progress')}
                </UpdateButton>
              </UpdateProgressContainer>
              
              <DeleteButton onClick={() => onDeleteGoal(goal.id)}>
                {t('delete_goal')}
              </DeleteButton>
            </GoalActions>
          </GoalItem>
        );
      })}
    </GoalsListContainer>
  );
};

export default GoalsList;